interface BomLinePartSelection {
	partId: number;
}

export function applySelectedBomLinePartId<T extends { bomLinePart: BomLinePartSelection }>(
	values: T,
): Omit<T, "bomLinePart"> & { bomLinePartId: number } {
	const { bomLinePart, ...bomLine } = values;

	return {
		...bomLine,
		bomLinePartId: bomLinePart.partId,
	};
}
